import { Navigate, useParams } from 'react-router-dom';
import { useCatalog } from '../CatalogContext';
import { PageHero, SectionHead, ProductGrid, ProductFilters, useProductFilters } from '../components/Common';

export default function CategoryPage() {
  const { slug } = useParams();
  const { loading, categoryBySlug, byCategory } = useCatalog();
  const category = categoryBySlug(slug);
  const products = category ? byCategory(slug) : [];
  const f = useProductFilters(products);

  if (loading) {
    return (
      <>
        <PageHero title="Products" />
        <section><div className="container"><p className="muted">Loading products…</p></div></section>
      </>
    );
  }

  if (!category) return <Navigate to="/" replace />;

  return (
    <>
      <PageHero title={category.name} image={category.image} />

      <section>
        <div className="container">
          <SectionHead
            tag="Premium Collection"
            title={`${category.name} Products`}
            text={category.description || `Explore our premium range of ${category.name}.`}
          />
          {products.length ? (
            <>
              <ProductFilters {...f} count={f.filtered.length} />
              {f.filtered.length
                ? <ProductGrid products={f.filtered} />
                : <p className="muted">No products match this filter.</p>}
            </>
          ) : (
            <p className="muted">No products in this category yet.</p>
          )}
        </div>
      </section>
    </>
  );
}
